import { Component, EventEmitter, Inject, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { PaymentMethod } from '@ridango/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'ridango-multiple-payment-methods',
    templateUrl: './multiple-payment-methods.component.html',
    styleUrls: ['./multiple-payment-methods.component.scss']
})
export class MultiplePaymentMethodsComponent implements OnInit {
    @Input() methods = [];
    @Input() selectedMethod = null;
    @Input() lang = 'en';
    @Input() tabIndex = 0;
    @Output() onMethodSelected = new EventEmitter<any>();
    @Output() onMovedLeft = new EventEmitter<any>();
    @Output() onMovedRight = new EventEmitter<any>();
    @Output() onFocused = new EventEmitter<any>();
    @Output() onBlurred = new EventEmitter<any>();

    @ViewChildren('focusItems') focusItems: QueryList<any>;

    constructor(@Inject('ENV') public env: Env) {}

    ngOnInit() {}

    select(method) {
        this.onMethodSelected.emit(method);
    }

    movedLeft(method) {
        this.onMovedLeft.emit(method);
    }

    movedRight(method) {
        this.onMovedRight.emit(method);
    }

    focused(method) {
        this.onFocused.emit(method);
    }

    blurred(method) {
        this.onBlurred.emit(method);
    }

    getTabIndex(pm: PaymentMethod) {
        if (this.selectedMethod) {
            if (this.selectedMethod.payment_id === pm.payment_id) {
                // Selected item
                return 0;
            }
        } else if (this.methods[0].payment_id === pm.payment_id) {
            // First item
            return 0;
        }
        return -1;
    }

    isSelected(pm: PaymentMethod) {
        return (
            this.selectedMethod &&
            pm.payment_id === this.selectedMethod.payment_id &&
            ((!this.selectedMethod.token_id && !pm.token_id) || pm.token_id === this.selectedMethod.token_id)
        );
    }
}
